// extracted by mini-css-extract-plugin
export default {"figure":"Figure_figure__lI+9+"};